import * as React from "react";
import { Language } from "typings/index";
import { 
    CommandBar, 
    DefaultButton, 
    ICommandBarItemProps,
    TextField,
} from "office-ui-fabric-react";
import { Map } from "~/../typings";
import { GetLanguageMenu } from "./languageHelper";
import { ListItem } from "../fieldStyles";

import api from "../../../../services/api";

export interface Props
{
    onValueChange: (language: string, value: string[]) => void; 
    values?: Map<string[]>;
    languages: Language[];
    languageDefaultIndex: number;
    focus?: boolean;
    propertyName: string;
}
let timer: any = 0;
function TextListEditor(props: Props)
{
    const [language, setLanguage] = React.useState<Language>(props.languages[props.languageDefaultIndex]);
    const [searchResult, setSearchResult] = React.useState<{result: string[], index: number}>({ result: [], index: -1});
    
    const commandBarOptions: ICommandBarItemProps[] = GetLanguageMenu(props.languages, setLanguage, language);
    const onAddNewStringClick = React.useCallback(() =>
    {
        let temp: string[] = [];
        if (props.values && props.values[language.name])
        {
            temp =  props.values[language.name];
        }
        props.onValueChange(language.name, [...temp, ""]);
    }, [props.values, language]);

    const updateText = React.useCallback((index: number) => (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) =>
    {
        if (newValue)
        {
            if (props.values && props.values[language.name])
            {
                const temp  = [...props.values[language.name]];
                temp[index] = newValue;
                props.onValueChange(language.name, temp);
               
                if (newValue.length > 2)
                {
                    clearTimeout(timer);
                    timer = setTimeout( async () =>
                    {
                        let result = await api.translation.searchField(props.propertyName, language.name, newValue);
                        result = result.filter(x => temp.indexOf(x) === -1);
                        setSearchResult({result, index});
                    }, 200);
                }
              
                
            }
          
        }
      
    }, [language, props.values]);
    
    const onDeleteClick = React.useCallback((index: number) => () =>
    {
       
            if (props.values && props.values[language.name])
            {
                const temp =  props.values[language.name];
                temp.splice(index, 1);
                props.onValueChange(language.name, temp);
            }
          
      
    }, [language, props.values]);

    const setValueAtIndex = React.useCallback((index: number, value: string) => () =>
    {
       
            if (props.values && props.values[language.name])
            {
                const temp =  props.values[language.name];
                temp[index] = value;
                props.onValueChange(language.name, temp);
                setSearchResult({result: [], index: -1});
            }
          
      
    }, [language, props.values]);

    const renderStringList = React.useCallback(() =>
    {
        return props.values && props.values[language.name] && props.values[language.name].map((value, index) =>
        {
            console.log(searchResult, index);
            return <ListItem>
                <TextField  onChange={updateText(index)} key={index} value={value}></TextField>  
                <DefaultButton   onClick={onDeleteClick(index)}  iconProps={{iconName: "Delete"}} />
                {   
                    index === searchResult.index && searchResult.result.length > 0 ? 
                        <ul>
                            {searchResult.result.map(value => <li onClick={setValueAtIndex(index, value)}>{value}</li>)}
                        </ul>  
                    :null
                }
            </ListItem>;
        }); 
    }, [language, props.values, searchResult]);

    return (
        <div className="locale-textarea">
            <CommandBar
                style={{background: "transparent"}}
                items={commandBarOptions}
            />
            <div>
                {renderStringList()}
            </div>
             <DefaultButton 
                onClick={onAddNewStringClick}
                iconProps={{iconName: "Add"}} 
                text={"Add"} 
            />
        </div>
    );
}
export default TextListEditor;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/localeTextList/TextListEditor.tsx